import { render, staticRenderFns } from "./ReservationCalendar.vue?vue&type=template&id=5a16f5ab&scoped=true"
import script from "./ReservationCalendar.vue?vue&type=script&lang=ts"
export * from "./ReservationCalendar.vue?vue&type=script&lang=ts"
import style0 from "./ReservationCalendar.vue?vue&type=style&index=0&id=5a16f5ab&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a16f5ab",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
